/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An enumeration.
 * @export
 */
export const AWSCredentialsTypeEnum = {
    Key: 'key',
    Role: 'role'
} as const;
export type AWSCredentialsTypeEnum = typeof AWSCredentialsTypeEnum[keyof typeof AWSCredentialsTypeEnum];


export function AWSCredentialsTypeEnumFromJSON(json: any): AWSCredentialsTypeEnum {
    return AWSCredentialsTypeEnumFromJSONTyped(json, false);
}

export function AWSCredentialsTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AWSCredentialsTypeEnum {
    return json as AWSCredentialsTypeEnum;
}

export function AWSCredentialsTypeEnumToJSON(value?: AWSCredentialsTypeEnum | null): any {
    return value as any;
}

